import React from 'react';
import Personal from '../components/Personal';
import Footer from '../components/Footer';

function PersonalPage() {
  return (
    <div className="page">
      <main>
        <Personal />
      </main>
      <Footer />
    </div>
  );
}

export default PersonalPage;
